module.exports = __webpack_public_path__ + "img/phoneicon.2199a1cd.svg";